import * as _ from 'lodash'
import {
    DimensionType,
    IHierarchy,
    IHierarchyFilterOptions,
    IHierarchyLevel,
    IHierarchyNode
} from "../PA.Core/PA.Core.IF.Hierarchy";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {IMessageProvider} from "../PA.Core/PA.Core.IF.Basic";



export interface CreateOptions {}

export class FilteredHierarchy
    implements IHierarchy
{

    private srcHierarchy: IHierarchy
    private filterOptions: IHierarchyFilterOptions
    private _dimensionType: DimensionType
    private _hierarchyId: string
    private _hierarchyUI_Id: string
    private _hierarchyName: string

    private dctHierarchyLevels:   {[LevelId: string]: IHierarchyLevel}
    private dctNodes:             {[NodeId: string]: IHierarchyNode}
    private dctNodesByLevel:      {[LevelId: string]: IHierarchyNode[]}

    private dctNodeParentByChildId:     {[NodeId: string]: IHierarchyNode}
    private dctNodeChildrenByParentId:  {[NodeId: string]: IHierarchyNode[]}
    private arrTopLevelNodes:   IHierarchyNode[]

    private _loadMessageProvider: MessageProvider;
    private _OnLoadComplete:      Promise<void>
    private _bLoaded:             boolean


    constructor(aHierarchy: IHierarchy, options: IHierarchyFilterOptions) {
        this.srcHierarchy = aHierarchy
        this.filterOptions = options || {}
        this._dimensionType = aHierarchy.DimensionType
        this._hierarchyId = aHierarchy.HierarchyId
        this._hierarchyUI_Id = aHierarchy.HierarchyIdUI
        this._hierarchyName = aHierarchy.HierarchyName
        this._bLoaded = false
        this._loadMessageProvider = new MessageProvider()
        this.dctHierarchyLevels = {}
        this.dctNodes = {}
        this.dctNodesByLevel = {}
        this.dctNodeParentByChildId = {}
        this.dctNodeChildrenByParentId = {}
        this.arrTopLevelNodes = []
    }


    get DimensionType(): DimensionType {
        return this._dimensionType;
    }

    get HierarchyId(): string {
        return this._hierarchyId
    }

    get HierarchyIdUI(): string {
        return this._hierarchyUI_Id
    }

    get HierarchyName(): string {
        return this._hierarchyName
    }

    get LoadMessageProvider(): IMessageProvider {
        return this._loadMessageProvider
    }

    get bLoaded(): boolean {
        return this._bLoaded
    }


    get OnLoadComplete(): Promise<void> {
        const self = this

        if (self._bLoaded)
            return Promise.resolve()


        if (!_.isEmpty(self._OnLoadComplete))
            return self._OnLoadComplete

        let returnValue = self._OnLoadComplete = (async () => {
            let msg = ""
            self._loadMessageProvider.clearMessages()


            // TODO: -- Use srcHierarchy and filterOptions to subset existing hierarchy

            if (!self.srcHierarchy.bLoaded) {
                await self.srcHierarchy.OnLoadComplete
                this._dimensionType = self.srcHierarchy.DimensionType
                this._hierarchyId = self.srcHierarchy.HierarchyId
                this._hierarchyUI_Id = self.srcHierarchy.HierarchyIdUI
                this._hierarchyName = self.srcHierarchy.HierarchyName
                self.arrTopLevelNodes = self.srcHierarchy.getTopLevelNodes()
                self._bLoaded = true
            }
        })();


        return returnValue
    }

    getLevels(): IHierarchyLevel[] {
        let levels = this.srcHierarchy.getLevels()
        let returnValues: IHierarchyLevel[] = []
        if (levels.length > 0 && !_.isEmpty(this.filterOptions)) {
            if (!_.isEmpty(this.filterOptions.BottomLevel)) {
                let currentLevel = _.filter(levels, aLevel => aLevel.LevelId == this.filterOptions.BottomLevel)
                if (!_.isEmpty(currentLevel))
                    return _.filter(levels, aLevel => aLevel.LevelDepth <= currentLevel[0].LevelDepth)
            } else {
                if (!_.isEmpty(this.filterOptions.TopLevel)) {
                    let currentLevel = _.filter(levels, aLevel => aLevel.LevelId == this.filterOptions.TopLevel)
                    if (!_.isEmpty(currentLevel))
                        return _.filter(levels, aLevel => aLevel.LevelDepth >= currentLevel[0].LevelDepth)
                }
            }
        }
        returnValues = levels


        return returnValues
    }

    getTopLevelNodes(): IHierarchyNode[] {
        return this.arrTopLevelNodes;
    }

    getNode(NodeId: string): IHierarchyNode {
        return this.srcHierarchy.getNode(NodeId)
    }

    getNodes(): IHierarchyNode[] {
        return _.values(this.dctNodes)
    }


    getNodesAtLevel(HierarchyLevel: string): IHierarchyNode[] {
        return this.srcHierarchy.getNodesAtLevel(HierarchyLevel)
    }

    getChildren(nodes: IHierarchyNode[] | IHierarchyNode | string[] | string, levelId ?: string): IHierarchyNode[] {
        return this.srcHierarchy.getChildren(nodes, levelId);
    }

    getParents(nodes: IHierarchyNode[] | IHierarchyNode | string[] | string, levelId ?: string): { [NodeId: string]: IHierarchyNode } {
        let returnValue: { [NodeId: string]: IHierarchyNode } = this.srcHierarchy.getParents(nodes, levelId)

        return returnValue;
    }


}